"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAbsenceRequestApiResponseSchema = exports.createAdminAbsenceApiResponseSchema = exports.createAdminAbsenceApiPayloadSchema = void 0;
const zod_1 = require("zod");
const absence_enums_1 = require("./absence-enums");
const absence_queue_1 = require("./absence-queue");
/**
 * Payload for an admin creating an absence on behalf of an assistant. The
 * absence is persisted directly as approved with an `admin` origin.
 */
exports.createAdminAbsenceApiPayloadSchema = zod_1.z.object({
    type: absence_enums_1.absenceTypeSchema,
    fromDate: zod_1.z.string().date(),
    toDate: zod_1.z.string().date(),
    reason: zod_1.z.string().trim().min(1).optional(),
});
exports.createAdminAbsenceApiResponseSchema = zod_1.z.object({
    data: absence_queue_1.assistantAbsenceRequestApiResponseSchema,
});
/** Response of deleting an absence: the removed record, presented one last time. */
exports.deleteAbsenceRequestApiResponseSchema = zod_1.z.object({
    data: absence_queue_1.assistantAbsenceRequestApiResponseSchema,
});
